import { Check, Moon, Sun } from "lucide-react";
import type { FunctionComponent } from "react";
import { Button, Dropdown, type MenuProps } from "~/components/ui";
import { useTranslation } from "react-i18next";
import { useSetThemeMode, useThemeMode } from "~/store/ui-preferences.store";
import type { ThemeMode } from "@noa/theme";

interface Choices {
  code: ThemeMode;
  selectionLabel: string;
  icon: React.ReactNode;
}

export const AppThemeSelector: FunctionComponent = () => {
  const { t } = useTranslation();
  const themeMode = useThemeMode();
  const setThemeMode = useSetThemeMode();
  const choices: Choices[] = [
    { code: "light", selectionLabel: t("theme:light"), icon: <Sun size={14} /> },
    { code: "dark", selectionLabel: t("theme:dark"), icon: <Moon size={14} /> },
  ];

  const menuItems: MenuProps["items"] = choices.map(({ code, selectionLabel, icon }) => {
    const isSelected = themeMode === code;

    return {
      key: code,
      disabled: isSelected,
      onClick: () => setThemeMode(code),
      label: (
        <div className="flex items-center gap-2">
          {icon} {selectionLabel} {isSelected && <Check size={10} />}
        </div>
      ),
    };
  });

  const currentTheme = choices.find(({ code }) => code === themeMode);
  const currentIcon = currentTheme?.icon || <Sun size={14} />;

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight">
      <Button className="border-2" variant="default" shape="circle" icon={currentIcon} />
    </Dropdown>
  );
};
